/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isString from 'lodash/isString';
import isNil from 'lodash/isNil';
import FileSystemType from '../file/system/file-system-type';

/**
 * Utilitární třída pro pomoc při parsování řetezce pro výběr úlošitě.
 */
class StorageTypesParser {
  /**
   * Naparsuje řetězec priorit úložiště do dvou rozměrného pole.
   * @param {string} storageString
   * @returns {Array.<FileSystemType[]>|null}
   */
  static parse(storageString) {
    if (isNil(storageString) || !isString(storageString)) {
      return null;
    }
    return storageString
      .split(';')
      .map((group) => group.split('|'))
      .map((units) =>
        units
          .map((unit) => {
            switch (unit.trim()) {
              case 'internal':
                return FileSystemType.Internal;
              case 'usb':
                return FileSystemType.Usb;
              case 'sdcard':
                return FileSystemType.SdCard;
              default:
                return null;
            }
          })
          .filter((unit) => Boolean(unit))
      )
      .filter((u) => Array.isArray(u) && u.length > 0);
  }

  /**
   * Převede dvou rozměrné pole s na řetězec priorit úložiště.
   * @param {Array.<FileSystemType[]>} storageTypes
   * @returns {string|null}
   */
  static toString(storageTypes) {
    if (!Array.isArray(storageTypes) || isNil(storageTypes)) {
      // TODO: neni to blbnost??
      return null;
    }
    return storageTypes
      .map((arr) => arr.filter((a) => Boolean(a)).join('|'))
      .join(';');
  }
}

export default StorageTypesParser;
